import React from 'react';
import { AirportDetails } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import style from './airports.module.scss';
import { LabeledItem } from 'acscp/components/common/labeledItem';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';

const AirportsContent: React.SFC<{ airports: AirportDetails[] }> = ({airports}) => {
    if (airports.length === 0) {
        return null;
    }

    const additionalDetailsToFollow = airports.filter(x => !x.address || !x.directions || !x.reportTo || x.telephoneNumber).length !== 0;

    return (
        <div className={style.Container}>
            <div className={style.InnerContainer}>
                {airports.map((airport, index) => (
                    <div key={index} className={style.ItemContainerBordered}>
                        <div className={style.AirportName}>
                            {airport.location}
                        </div>
                        <LabeledItem
                            label={
                                <FormattedMessage
                                    id={'components.itinerary.airports.reportTo'}
                                    defaultMessage={'Report To'}
                                />}
                        >
                            {airport.reportTo}
                        </LabeledItem>
                        <LabeledItem
                            label={
                                <FormattedMessage
                                    id={'components.itinerary.airports.address'}
                                    defaultMessage={'Address'}
                                />}
                        >
                            {airport.address}
                        </LabeledItem>
                        <LabeledItem
                            label={
                                <FormattedMessage
                                    id={'components.itinerary.airports.directions'}
                                    defaultMessage={'Directions'}
                                />}
                        >
                            {airport.directions}
                        </LabeledItem>
                        <LabeledItem
                            label={
                                <FormattedMessage
                                    id={'components.itinerary.airports.reportTime'}
                                    defaultMessage={'Report Time'}
                                />}
                            className={style.ReportTime}
                        >
                            {airport.reportTime}
                        </LabeledItem>
                        <LabeledItem
                            label={
                                <FormattedMessage
                                    id={'components.itinerary.airports.telephone'}
                                    defaultMessage={'T'}
                                />}
                        >
                            {airport.telephoneNumber}
                        </LabeledItem>
                    </div>
                ))}
                {additionalDetailsToFollow &&
                    <div className={style.AdditionalDetails}>
                        <FormattedMessage
                            id={'components.itinerary.airports.additionalDetails'}
                            defaultMessage={'Additional details to follow'}
                        />
                    </div>
                }
            </div>
        </div>
    );
};

const Airports = withCollapsable(
    (
        <Title>
            <FormattedMessage id={'components.itinerary.airportDetailsTitle'} defaultMessage={'AIRPORT DETAILS'} />
        </Title>
    ),
    AirportsContent);
export { Airports };
